import { Box, Grid, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import LeafBlue from '../assets/images/LeafBlue.svg';
import LeafGreen from '../assets/images/LeafGreen.svg';

const BannerBlock = ({name,color}) => {

    const [icon, setIcon] = useState(LeafGreen);

    useEffect(() => {
      switch (color) {
        case "#69AF45": //G
            setIcon(LeafGreen);
            break;
        case "#105385": //B
            setIcon(LeafBlue);
            break;
        case "#2B8DCC": //B
            setIcon(LeafBlue);
            break;
        case "#519342": //G
            setIcon(LeafGreen);
            break;
        default:
            setIcon(LeafGreen);
      }
    }, [color])

    return (
    <Box>
        <Grid container sx={{alignItems:"stretch"}}>
            <Grid size={10} sx={{ padding:"24px 48px", display:"flex", alignItems:"center", backgroundColor:color}}>
                <Typography variant="h4" fontWeight={500} color="white">{name}</Typography>
            </Grid>
            <Grid display={"flex"} justifyContent={"center"} alignItems={"center"} size={2} sx={{padding:"16px 24px", backgroundColor:`${color}20`}}>
                <img src={icon} style={{width:"60px"}} alt='LOGO_KNOW2GROW'/>
            </Grid>
        </Grid>
    </Box>
    )
}

export default BannerBlock